import { Typography } from 'antd';
import { ContainerOutlined } from '@ant-design/icons';
import ConfirmationModal from 'components/new-ui/composed/modal/confirmation-modal/ConfirmationModal';

type Props = {
    open: boolean;
    onConfirm: () => void;
    onCancel: () => void;
};

const ArchiveDeclarationModal = ({ open, onCancel, onConfirm }: Props) => {
    return (
        <ConfirmationModal
            width={400}
            open={open}
            onConfirm={onConfirm}
            onCancel={onCancel}
            icon={<ContainerOutlined />}
            title="Archive Declaration?"
            confirmButtonText="Archive"
            content={<Typography.Text>The declaration will be added to the archive.</Typography.Text>}
        />
    );
};

export default ArchiveDeclarationModal;
